import { createSelector } from 'reselect';
import { ConfigurationState } from '../../model/ConfigurationModel';
import { RootReducer } from '../rootReducer';

export const selectConfiguration = createSelector(
	(state: RootReducer) => state.configurationReducer,
	(configurationReducer: ConfigurationState) => configurationReducer
);
